import axios from '@axios'

const route = 'register/customer'

export default {
  namespaced: true,
  state: {
    customers: [],
    addresses: [],
  },
  getters: {
    getCustomers(state) {
      return state.customers
    },
    getAddresses(state) {
      return state.addresses
    },
  },
  mutations: {
    setCustomers(state, customers) {
      state.customers = customers
    },
    setAddresses(state, addresses) {
      state.addresses = addresses
    },

  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, filters,
    }) {
      return axios.post(`${route}/index?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filters)
    },

    store(context, stage) {
      return axios.post(route, stage)
    },

    update(context, stage) {
      return axios.put(`${route}/${stage.id}`, stage)
    },

    uploadImage(context, image) {
      const formData = new FormData()
      formData.append('img', image.img)

      return axios.post(`${route}/avatar/${image.customer_id}`, formData)
    },

    loadAvatar(context, customer_id) {
      return axios.get(`${route}/load_avatar/${customer_id}`)
    },

    removeImage(context, data) {
      return axios.delete(`${route}/remove_avatar/${data.customer_id}`)
    },
    getExportExcel(context, {
      itemsPerPage, page, search, filters,
    }) {
      return axios.post(`${route}/export_excel?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filters, { responseType: 'blob' })
    },

    destroy(context, stage) {
      return axios.delete(`${route}/${stage.id}`)
    },

    getStates() {
      return axios.get('helper/states')
    },

    getCities(context, state_id) {
      return axios.get(`helper/cities/${state_id}`)
    },

    // ENDERECO
    saveAddress(context, address) {
      return axios.post(`${route}/address`, address)
    },
    destroyAddress(context, address) {
      return axios.delete(`${route}/address/${address.id}`)
    },
  },
}
